import { useHandlers } from '../../../context/page-context';
import type { ThemesApiContract } from '../api';

export function useThemesApi(): { themesApi: ThemesApiContract } {
  const { apis } = useHandlers();
  return { themesApi: apis.themes };
}
